<sesio-chart [kind]="kind" [options]="options" (ready)="loadData($event)">
</sesio-chart>
